import React from "react";
import BaseGridContainer from "../../sisu/layout/BaseGridContainer.sisu";

const NeoGridContainer = (props) => {
  return (<BaseGridContainer subCustom="p-grid" {...props}/>);
};

export default NeoGridContainer;